import { LayoutDashboard, MapPin, Globe, Megaphone, BookOpen } from 'lucide-react';
import type { NavConfig } from './nav.types';

/**
 * Editor (Ambassador) portal navigation
 * Minimal, editorial workspace – no customer items
 */
export const editorNav: NavConfig = [
  {
    items: [
      {
        label: 'Översikt',
        href: '/app/editor',
        icon: LayoutDashboard,
        exact: true,
      },
      {
        label: 'Mina platser',
        href: '/app/editor/places',
        icon: MapPin,
      },
      {
        label: 'Mina områden',
        href: '/app/editor/areas',
        icon: Globe,
      },
      {
        label: 'Inspiration',
        href: '/app/editor/inspiration',
        icon: BookOpen,
      },
      {
        label: 'Publicering',
        href: '/app/editor/publicering',
        icon: Megaphone,
      },
    ],
  },
];
